import * as _ from 'lodash'
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Customer, esWB_Finished_Product, esWB_Product_Group} from "../PA.Core/PAdbSchema";
import {WB_CustomerRow, WB_FinishedProductRow, WB_PlanRow, WB_ProductGroupRow} from "../PA.Core/PAdbSchemaRows";
import {ASync} from "../PA.Core/Basic/ASync";
import {IDateRange} from "../PA.Core/PA.Core.IF.Basic";
import {PASearch} from "../PA.Core/PASearch";
import {SourceCustomerService} from "../PA.MD.Services/SourceCustomerService";
import {PAusrContext} from "../PA.Core/PAusrContext";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {DateUtils} from "../PA.Core/Basic/Dates";


export interface EquivRatesDictionary {[wb_prdgrp_id:number]: {[wb_prd_id: number]: number} }

export class CannibalizationDataUtils {

  static getAffinityGroupProducts(aDbContext: PAdbContext, ProductGroups: WB_ProductGroupRow[]): Promise<WB_FinishedProductRow[]> {

    return new Promise<WB_FinishedProductRow[]>((resolve, error) => {

      let condition:any = {}

      condition.WB_PRDGRP_ID_PRNT = {inq: _.map(ProductGroups, (aWBPrdGrp) => { return aWBPrdGrp.cif.WB_PRDGRP_ID })}

      PASearch.find("vUI_CannibalizationAffinityGroup_PrdRel",  condition, {WB_PRDGRP_ID_PRNT: {type: "number"},WB_PROD_ID: {type: "number"}},[], 0, ['WB_PROD_ID'])
        .then((results: any[]) => {
          if (_.isEmpty(results)) {
            resolve([])
          }

          let arrWB_Prd_IDs = _.map(results, (aRow) => {return _.toNumber(aRow.WB_PROD_ID) } )

          return aDbContext.findUsingCache(esWB_Finished_Product, arrWB_Prd_IDs)

        })
        .then((wbProducts: WB_FinishedProductRow[]) => {
          if (_.isEmpty(wbProducts)) {
            resolve([])
            return
          }

          resolve(wbProducts)
        })
        .catch((err) => {
          error(err)
        })

    })

  }


  static getAffinitySetProductGroups(aDbContext: PAdbContext, ProductGroups: WB_ProductGroupRow[]): Promise<WB_ProductGroupRow[]> {

    return new Promise<WB_ProductGroupRow[]>((resolve, error) => {

      let condition:any = {}

      condition.WB_PRDGRP_ID_PRNT = {inq: _.map(ProductGroups, (aWBPrdGrp) => { return aWBPrdGrp.cif.WB_PRDGRP_ID })}

      PASearch.find("vUI_Cannibalization_PrdGrpRel",  condition, {WB_PRDGRP_ID_PRNT: {type: "number"},WB_PRDGRP_ID: {type: "number"}},[], 0, ['WB_PRDGRP_ID'])
        .then((results: any[]) => {
          if (_.isEmpty(results)) {
            resolve([])
          }

          let arrWB_PrdGrp_IDs = _.map(results, (aRow) => { return _.toNumber(aRow.WB_PRDGRP_ID) })

          return aDbContext.findUsingCache(esWB_Product_Group, arrWB_PrdGrp_IDs)

        })
        .then((wbProductGroups: WB_ProductGroupRow[]) => {
          if (_.isEmpty(wbProductGroups)) {
            resolve([])
            return
          }

          resolve(wbProductGroups)
        })
        .catch((err) => {
          error(err)
        })

    })

  }





  static getProductGroupProductEqvRates( ProductGroupsWBIDs: number[]): Promise<EquivRatesDictionary> {

    if(_.isEmpty(ProductGroupsWBIDs)){
      return ASync.resolve({})
    }

    return new Promise<EquivRatesDictionary>((resolve, error) => {

      let condition:any = {}

      condition.WB_PRDGRP_ID_PRNT = {inq: ProductGroupsWBIDs}

      PASearch.find("vUI_CannibalizationAffinityGroup_PrdRel",  condition,
            {WB_PRDGRP_ID_PRNT: {type: "number"}, WB_PROD_ID: {type: "number"}, EQV_UNIT_RATE: {type: "number"}},
        [], 0, ['WB_PRDGRP_ID_PRNT','WB_PROD_ID','EQV_UNIT_RATE'])
        .then((results: any[]) => {
          if (_.isEmpty(results)) {
            resolve({})
          }

          let dctEqvRates:EquivRatesDictionary = {}

          _.forEach(results, (aRow) => {
            let aPrdGrpWBId: number = _.toNumber(aRow.WB_PRDGRP_ID_PRNT)
            let aPrdWBId: number = _.toNumber(aRow.WB_PROD_ID)
            let aEqvRt: number = _.toNumber(aRow.EQV_UNIT_RATE)

            if(!(aPrdGrpWBId in dctEqvRates)){
              dctEqvRates[aPrdGrpWBId] = {}
            }

            (dctEqvRates[aPrdGrpWBId])[aPrdWBId] = aEqvRt
          })

          resolve(dctEqvRates)
        })
        .catch((err) => {
          error(err)
        })

    })

  }


}